export default __webpack_public_path__ + "static/media/s6-img.ccba809e.png";